import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './i18n';
import './index.css';
import { applyTheme, readStoredTheme } from './themes/registry';
import { initBugsnag } from './lib/bugsnag';

// Bugsnag must initialize BEFORE React mounts so its instrumented fetch
// + global error handlers are in place when components start rendering.
// initBugsnag is a no-op when VITE_BUGSNAG_API_KEY is empty (dev / tests);
// in that case the returned ErrorBoundary is a transparent passthrough.
const BugsnagErrorBoundary = initBugsnag();

applyTheme(readStoredTheme());

// Bugsnag's React ErrorBoundary catches uncaught render errors anywhere
// in the tree, ships them, and renders the FallbackComponent. When
// Bugsnag isn't initialized (no API key), the boundary is a passthrough
// and falls back to React's default error handling.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BugsnagErrorBoundary FallbackComponent={AppFatal}>
      <App />
    </BugsnagErrorBoundary>
  </StrictMode>
);

function AppFatal({ clearError }: { error: Error; clearError: () => void }) {
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        background: '#fdfaf3',
        color: '#2a2520',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>
        Une erreur inattendue s&apos;est produite
      </h1>
      <p style={{ marginBottom: '1.5rem', maxWidth: 480 }}>
        Nous avons été notifiés. Veuillez recharger la page ou réessayer
        plus tard.
      </p>
      <button
        type="button"
        onClick={() => {
          clearError();
          window.location.reload();
        }}
        style={{
          padding: '0.6rem 1.4rem',
          border: '1px solid #8B6D3F',
          background: '#8B6D3F',
          color: 'white',
          borderRadius: 6,
          cursor: 'pointer',
        }}
      >
        Recharger
      </button>
    </div>
  );
}
